import { cn } from '@/lib/utils';

/**
 * Non-component styling/validation helpers for the auth sheets, split from the
 * components in `auth-form-ui.tsx` so that file stays Fast-Refresh-safe
 * (react-refresh/only-export-components).
 *
 * Values mirror the ARC-145 Figma (node 5751-140495): 48px fields with 1.5px
 * borders and 16px text; a 270×50px capitalized CTA on the brand gradient
 * running dark→light (grad-3 → grad-1, same as AccountStatusGate's Button-Big)
 * with the drop + inset-highlight shadows.
 */

/** Pill input classes; the field with the active error gets a red border. */
export function fieldInputClasses(error?: boolean, extra?: string) {
  return cn(
    'h-12 w-full rounded-[33px] bg-input-soft border-[1.5px] px-[22px] text-base text-ink placeholder:text-muted focus:outline-none disabled:opacity-50',
    error ? 'border-danger-alt focus:border-danger-alt' : 'border-border focus:border-purple',
    extra,
  );
}

/** Brand-gradient CTA pill ("Button - Big"); solid gray when disabled, per the designs. */
export const primaryCtaClasses = [
  'h-[50px] w-[270px] max-w-full self-center rounded-[51px] capitalize text-white text-2xl font-semibold',
  'bg-[linear-gradient(139deg,var(--color-brand-grad-3)_0%,var(--color-brand-grad-2)_50%,var(--color-brand-grad-1)_100%)]',
  'shadow-[0px_1.818px_1.818px_rgba(0,0,0,0.15),inset_0px_2px_4px_rgba(255,255,255,0.3)]',
  'hover:opacity-95 disabled:bg-none disabled:bg-neutral-400 disabled:shadow-none',
].join(' ');

/** Client-side email shape check, mirroring the designs' inline validation. */
const EMAIL_REGEX = /^\S+@\S+\.\S+$/;
export function isValidEmail(email: string): boolean {
  return EMAIL_REGEX.test(email.trim());
}

/** The designs' invalid-email helper copy, shared by signup and login. */
export const INVALID_EMAIL_MESSAGE = '*Please enter a valid email';
